import React, {
  ChangeEventHandler,
  LegacyRef,
  MouseEventHandler,
  Ref,
  RefObject,
  useEffect,
  useRef,
  useState,
} from "react";
import { Input, Skeleton } from "antd";
import CandidateAvatar from "../../components/Avatars/CandidateAvatar";
import Location from "../../assets/images/bx-location-plus.svg";
import ToMessage from "../../components/chats/ToMessage";
import FromMessage from "../../components/chats/FromMessage";
import MessageSendButton from "../../components/chats/MessageSendButton";
import "../../css/chats.css";
import { ChatMessageDetailsType, ChatMessageType } from "../../interfaces/chats";
import InterviewInviteMessage from "./InterviewInvite";
import { isEmpty, isNil } from "lodash";
import { COLOR_CONSTANTS } from "../../constants/stringConstants";

interface chatSecProps {
  chatDetails: ChatMessageDetailsType;
  chatMessages: ChatMessageType[];
  updateInput: ChangeEventHandler<HTMLInputElement>;
  refreshList: Function;
  value: string;
  sendMessage: (
    event: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>
  ) => void;
  isChatLoading: boolean;
}

function ChattingSec(props: chatSecProps) {
  // const scrollToBottom = useScrollToBottom();

  const chatRef = useRef<HTMLInputElement>(null);

  const { chatDetails, chatMessages, value, updateInput, sendMessage, refreshList, isChatLoading } =
    props;
  const { jobApplication } = chatDetails;
  // const { companyJob } = jobApplication;

  const onPress = () => {
    chatRef?.current?.scrollBy(0, 20000);
  };

  useEffect(() => {
    onPress();
  }, [chatMessages]);

  return (
    <div className="c2-candidate-msgs__r1-candidate-info">
      {/* ///abc */}

      {!isNil(jobApplication) && !isChatLoading ? (
        <div className="chat_profile_container">
          <div className="chat_profile_info">
            {!jobApplication?.companyJob?.company?.companyLogo ? (
              <CandidateAvatar />
            ) : (
              <img
                src={jobApplication?.companyJob?.company?.companyLogo}
                style={{ width: "60px", height: "60px", borderRadius: "100px" }}
              />
            )}
            <div>
              <div className="chat_message_sec_title_company">
                <text>{jobApplication?.companyJob?.company?.companyName}</text>
                <text>{jobApplication?.companyJob?.jobTitle}</text>
              </div>
            </div>
          </div>
          <div className="chat_profile_location">
            <img src={Location} />
            <text>Karachi</text>
          </div>
        </div>
      ) : (
        <div className="chat_message_header">
          <Skeleton
            active
            avatar={{ size: 100 }}
            paragraph={{ style: { height: 40, width: "80%" } }}
          />
        </div>
      )}

      <div
        style={{
          borderBottom: "1px solid #f1f1f5",
          marginTop: "12px",
          marginBottom: "4px",
        }}
      />

      <div className="c2-candidate-msgs__r2-candidate-msgs-container">
        <div className="r2-candidate-msgs-container__to-and-from-msgs" ref={chatRef}>
          {!isEmpty(chatMessages) && !isChatLoading ? (
            chatMessages.map((chat, i) => {
              let chatObj = {
                createdAt: chat.createdAt,
                content: chat.content,
              };
              return chat.fromUser === "COMPANY" && chat.chatType == "CHAT" ? (
                <FromMessage
                  chat={chatObj}
                  profileImage={jobApplication?.companyJob?.company?.companyLogo}
                />
              ) : chat.fromUser === "COMPANY" && chat.chatType == "INTERVIEW" ? (
                chat?.interview && (
                  <InterviewInviteMessage
                    chat={chat}
                    refreshList={refreshList}
                    profileImage={jobApplication?.companyJob?.company?.companyLogo}
                  />
                )
              ) : (
                <ToMessage chat={chatObj} />
              );
            })
          ) : (
            <div>
              <div className="chat_message_right_side">
                <Skeleton
                  avatar
                  paragraph={{
                    rows: 1,
                    width: "50%",
                  }}
                />
              </div>

              <div className="chat_message_left_side">
                <Skeleton
                  avatar
                  title={false}
                  paragraph={{
                    rows: 1,
                    width: "50%",
                  }}
                />
              </div>
              <div className="chat_message_right2_side">
                <Skeleton
                  avatar
                  title={false}
                  paragraph={{
                    rows: 1,
                    width: "50%",
                  }}
                />
              </div>

              <div className="chat_message_left_side">
                <Skeleton
                  avatar
                  title={false}
                  paragraph={{
                    rows: 1,
                    width: "50%",
                  }}
                />
              </div>
              <div className="chat_message_right2_side">
                <Skeleton
                  avatar
                  title={false}
                  paragraph={{
                    rows: 1,
                    width: "50%",
                  }}
                />
              </div>

              <div className="chat_message_left_side">
                <Skeleton
                  avatar
                  title={false}
                  paragraph={{
                    rows: 1,
                    width: "50%",
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="img-input-div__warning-input" onKeyDown={sendMessage}>
        {/* <div className="iid-warning-input__warning-div">
    <h3>This candidate missed interview(s) in the past</h3>
  </div> */}
        <Input
          disabled={isChatLoading}
          value={value}
          onChange={updateInput}
          className="iid-warning-input__custom-ant-input"
          placeholder="Write your message here"
          suffix={<MessageSendButton onMessageSend={sendMessage} />}
        />
      </div>
    </div>
  );
}

export default ChattingSec;
